/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ReadEMARequestBody = {
  remoteSessionIssuerId: string;
  /**
   * Canonical intended resource URI.
   */
  resource: string;
  userSessionIssuerId: string;
};

/** @internal */
export type ReadEMARequestBody$Outbound = {
  remote_session_issuer_id: string;
  resource: string;
  user_session_issuer_id: string;
};

/** @internal */
export const ReadEMARequestBody$outboundSchema: z.ZodMiniType<
  ReadEMARequestBody$Outbound,
  ReadEMARequestBody
> = z.pipe(
  z.object({
    remoteSessionIssuerId: z.string(),
    resource: z.string(),
    userSessionIssuerId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      remoteSessionIssuerId: "remote_session_issuer_id",
      userSessionIssuerId: "user_session_issuer_id",
    });
  }),
);

export function readEMARequestBodyToJSON(
  readEMARequestBody: ReadEMARequestBody,
): string {
  return JSON.stringify(
    ReadEMARequestBody$outboundSchema.parse(readEMARequestBody),
  );
}
